import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, of as observableOf } from 'rxjs';

import { AbstractFormComponent } from '../../../shared/crud/component/form.component';
import { TimezoneStorage } from '../../../shared/misc/service/timezone-storage';
import { DeviceFingerprintService } from '../../service/device-fingerprint-service';
import { SessionManager } from '../../service/session-manager';
import { SessionTokenService } from '../../service/session-token';
import { LoginForm } from './login.form';
import { ISessionResponse } from './response.interface';
import { UrlBuilder } from '../../../shared/crud/api/url-builder';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'session-login',
  templateUrl: './login.component.html',
  styleUrls: [ './login.component.scss' ],
})
export class LoginComponent extends AbstractFormComponent implements OnInit, AfterViewInit {

  regionSwitches = environment.regionSwitches;

  constructor(loginForm: LoginForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute,
              protected sessionService: SessionTokenService,
              protected sessionManager: SessionManager,
              protected deviceFingerprintService: DeviceFingerprintService) {
    super(loginForm, httpClient, toastrService, router, route);

    if (this.sessionService.isAuthenticated()) {
      this.router.navigate([ '/campaign' ]);
    } else {
        this.httpClient.get(`${environment.http.globalApiUri}/auth/start?app_id=cms&return_to=${environment.http.globalCMSUri}`)
            .subscribe((response: any) => {
                window.location.href = response.authorizeUrl;
            });

    }
  }

  ngAfterViewInit() {
    this.deviceFingerprintService.id$()
      .subscribe(id => this.form.controls.deviceId.patchValue(id, { emitEvent: false }));
  }

  ngOnInit() {
    super.ngOnInit();
  }

  populate(): Observable<any> {
    return observableOf(false);
  }

  getUrl(): string {
    return '/session/user';
  }

  onSubmit(result: ISessionResponse): void {
    TimezoneStorage.store(result.timezone);
    this.sessionService.persistWithExpiry(result, result.expiresIn);

    if (result.role === 'ADMIN') {
      this.router.navigate([ '/admin/accounts' ]);
      return;
    }
    this.router.navigate([ '/campaign' ]);
  }
}
